import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Build absolute URL for a photo path returned from the API.
// Server serves photos at /api/photos/{path}.
export function photoUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${API}/photos/${path}`;
}

export async function uploadPhoto(file, token) {
  const form = new FormData();
  form.append("file", file);
  const r = await axios.post(`${API}/upload/photo`, form, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return r.data.path;
}
